import styled from "styled-components";
import theme from "../../../styles/theme";

export const ChartBlock = styled.div`
  width: 100%;
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ChartHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
`;

export const ChartTitle = styled.h4`
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: ${theme.colors.white};
  margin: 0;
`;

export const ChartControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

/** Sits under the plot, aligned with its left edge — not competing with the title above it. */
export const ChartHint = styled.span`
  display: block;
  margin-top: 8px;
  text-align: left;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  color: ${theme.colors.grey};

  @media (max-width: ${theme.breakpointsCustom.md}px) {
    display: none;
  }
`;

export const ResetButton = styled.button`
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.green};
  background: transparent;
  border: 1px solid ${theme.colors.green};
  border-radius: 4px;
  padding: 4px 10px;
  cursor: pointer;

  &:hover {
    background: ${theme.colors.green}26;
  }
`;

export const SessionTypeGroup = styled.div`
  display: flex;
  gap: 4px;
`;

export const SessionTypeButton = styled.button`
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 4px;
  cursor: pointer;
  background: ${({ $active }) => ($active ? theme.colors.green : "transparent")};
  color: ${({ $active }) => ($active ? theme.colors.dark : theme.colors.grey)};
  border: 1px solid ${({ $active }) => ($active ? theme.colors.green : theme.colors.secondaryDark)};

  &:hover {
    color: ${({ $active }) => ($active ? theme.colors.dark : theme.colors.white)};
  }
`;

/** Claims sideways drags and two-finger pinch, leaving vertical page scrolling alone (see useChartZoom). */
export const ChartSurface = styled.div`
  width: 100%;
  height: 340px;
  background: ${theme.colors.darkLight};
  border-radius: 8px;
  padding: 12px 8px 8px 0;
  cursor: crosshair;

  /* recharts' accessibility layer makes the plot focusable (tabindex="0", role="application"), so
     clicking it to drag paints a focus ring — and Chrome draws that ring around the bounding box
     of the painted area path, not around the svg, which reads as a white frame slapped over the
     chart. Kill every ring inside, and put one deliberate indicator on the surface itself, only
     for readers who arrived by keyboard. */
  &:focus,
  :focus {
    outline: none;
  }

  &:has(:focus-visible) {
    outline: 2px solid ${theme.colors.green};
    outline-offset: 2px;
  }

  @media (max-width: 650px) {
    height: 260px;
  }
`;

export const EmptyMessage = styled.div`
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  color: ${theme.colors.grey};
  background: ${theme.colors.darkLight};
  border-radius: 8px;
  padding: 32px 16px;
  text-align: center;
`;

export const TooltipCard = styled.div`
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  background: ${theme.colors.dark};
  border: 1px solid ${theme.colors.secondaryDark};
  border-radius: 6px;
  padding: 8px 10px;
  color: ${theme.colors.white};
  line-height: 1.5;
`;

export const TooltipTitle = styled.div`
  font-weight: 600;
  margin-bottom: 2px;
`;

export const TooltipMeta = styled.div`
  color: ${theme.colors.grey};
`;
